import Block from 'components/Block'
import ContentBox from 'components/ContentBox'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import TextTitleCompressedLight from 'components/TextTitleCompressedLight'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles/index.js'

const messages = defineMessages({
  title: {
    id: 'TrackCaloriesHowItWorks.title',
    defaultMessage: 'How It Works'
  },
  stepIndex: {
    id: 'TrackCaloriesHowItWorks.stepIndex',
    defaultMessage: 'Step {index}'
  },
  logMealsFast: {
    id: 'TrackCaloriesHowItWorks.logMealsFast',
    defaultMessage: 'Log Meals Fast'
  },
  logMealsFastDescription: {
    id: 'TrackCaloriesHowItWorks.logMealsFastDescription',
    defaultMessage: 'Snap a photo, use your voice, or type it in. Our AI instantly calculates calories and macros in seconds.'
  },
  seeYourTotals: {
    id: 'TrackCaloriesHowItWorks.seeYourTotals',
    defaultMessage: 'See Your Totals'
  },
  seeYourTotalsDescription: {
    id: 'TrackCaloriesHowItWorks.seeYourTotalsDescription',
    defaultMessage: 'Get a clear view of your daily calories, protein, carbs, and fats. No more manual math or endless searches.'
  },
  stayOnTrack: {
    id: 'TrackCaloriesHowItWorks.stayOnTrack',
    defaultMessage: 'Stay On Track'
  },
  stayOnTrackDescription: {
    id: 'TrackCaloriesHowItWorks.stayOnTrackDescription',
    defaultMessage: 'Stay consistent with smart reminders and progress tracking that keeps you accountable to your goals.'
  }
})

const STEPS = [
  {
    titleMessage: messages.logMealsFast,
    descriptionMessage: messages.logMealsFastDescription
  },
  {
    titleMessage: messages.seeYourTotals,
    descriptionMessage: messages.seeYourTotalsDescription
  },
  {
    titleMessage: messages.stayOnTrack,
    descriptionMessage: messages.stayOnTrackDescription
  }
]

export function TrackCaloriesHowItWorks () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='black'
      style={{
        color: 'white',
        textAlign: 'center'
      }}
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View
          mb={4}
        >
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>
        <View
          row={!isSmallScreen}
          centered
        >
          {
            STEPS.map((step, index) => {
              const {
                titleMessage,
                descriptionMessage
              } = step
              return (
                <ContentBox
                  key={index}
                  f
                  mt={isSmallScreen}
                  bgc={null}
                >
                  <TextTitleCompressedLight
                    style={{
                      color: 'white'
                    }}
                  >
                    {formatMessageIntlUtil(intl, messages.stepIndex, { index: index + 1 })}
                  </TextTitleCompressedLight>
                  <TextTitleCompressedHeavyUpperCase
                    mt
                    style={{
                      fontSize: STYLES_FONT_SIZE.HEADING_SMALL
                    }}
                  >
                    {formatMessageIntlUtil(intl, titleMessage)}
                  </TextTitleCompressedHeavyUpperCase>
                  <View mt>
                    <TextBody mt>
                      {formatMessageIntlUtil(intl, descriptionMessage)}
                    </TextBody>
                  </View>
                </ContentBox>
              )
            })
          }
        </View>
      </View>
    </Block>
  )
}
